import { Card, CardMedia, FilledInput, InputLabel, Grid } from "@mui/material";
import { styled } from "@mui/system";
import { InnerImageZoom } from "react-inner-image-zoom";

export const CustomCard = styled(Card)({
  margin: 13,
  marginTop: 0,
  padding: 8,
  position: "relative",
});

export const ResultCard = styled(Card)({
  padding: 8,
  width: "100%",
  maxWidth: "1200px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "1rem",
});

// Display image for card on mobile
export const CustomCardMedia = styled(CardMedia)({
  paddingTop: 8,
  marginLeft: "auto",
  marginRight: "auto",
  width: "auto",
  maxWidth: "100%",

  "@media (min-width: 1200px)": {
    minHeight: "20vh",
    maxHeight: "29.5vh",
  },
});

// Display image for card on pc
export const CustomZoomImage = styled(InnerImageZoom)({
  margin: "auto !important",
  "& > div > img": {
    width: "auto !important",
    height: "auto !important",
    maxHeight: "29.5vh",
    minHeight: "20vh",
    maxWidth: "100%",
  },
});

export const CustomResultCardMedia = styled(CardMedia)({
  margin: "auto",
  width: "auto",
  maxWidth: "100%",
  maxHeight: "270px",
});

export const CustomIputLabel = styled(InputLabel)({
  whiteSpace: "pre-wrap",
  display: "inline",
});

export const CustomInput = styled(FilledInput)({
  paddingTop: "3px",
  paddingBottom: "3px",
});

// Display a label and a small text horizontally
export function SmallGridTexField(props) {
  return (
    <>
      <Grid item xs={12} md={2}>
        <CustomIputLabel htmlFor={props.id}>{props.label}</CustomIputLabel>
      </Grid>
      <Grid item xs={12} md={4}>
        <CustomInput
          id={props.id}
          size="small"
          value={props.value}
          disableUnderline
          readOnly
          fullWidth
          multiline
        />
      </Grid>
    </>
  );
}

// Display a label and a large text horizontally
export function LargeGridTexField(props) {
  if (props.multiline) {
    return (
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CustomIputLabel
              sx={{ ...(props.bold && { fontWeight: "bold" }) }}
              htmlFor={props.id}
            >
              {props.label}
            </CustomIputLabel>
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              sx={{ ...(props.bold && { fontWeight: "bold" }) }}
              id={props.id}
              size="small"
              value={props.value}
              disableUnderline
              readOnly
              fullWidth
              multiline
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
  return (
    <>
      <Grid item xs={12} md={2}>
        <CustomIputLabel
          sx={{ ...(props.bold && { fontWeight: "bold" }) }}
          htmlFor={props.id}
        >
          {props.label}
        </CustomIputLabel>
      </Grid>
      <Grid item xs={12} md={10}>
        <CustomInput
          sx={{ ...(props.bold && { fontWeight: "bold" }) }}
          id={props.id}
          size="small"
          value={props.value}
          disableUnderline
          readOnly
          fullWidth
          multiline
        />
      </Grid>
    </>
  );
}
